export const types = {
  OPEN: 'replaceParentDrawer/OPEN',
  CLOSE: 'replaceParentDrawer/CLOSE',
  SUBMIT: 'replaceParentDrawer/SUBMIT',
  SUCCESS: 'replaceParentDrawer/SUCCESS',
  FAILURE: 'replaceParentDrawer/FAILURE',
};

export const replaceParentDrawer = {
  open: ({ assemblyParentComponentId, quoteItemId }) => ({
    payload: { assemblyParentComponentId, quoteItemId },
    type: types.OPEN,
  }),
  close: () => ({
    type: types.CLOSE,
  }),
  submit: ({ isReplacingRootComponent, partUuid }) => ({
    payload: { isReplacingRootComponent, partUuid },
    type: types.SUBMIT,
  }),
  success: () => ({
    type: types.SUCCESS,
  }),
  failure: () => ({
    type: types.FAILURE,
  }),
};
